module.exports = __webpack_public_path__ + "static/media/exclusive-combo-wheels.6afc2fb9.jpg";